import {Modal} from 'antd'
import getLinkToDetail from 'helpers/getLinkToDetail'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React from 'react'
import {useToggle} from 'react-use'
import {NullAsDefault} from 'views/Shared'
import EmptyHolder from '../../../components/EmptyHolder'
import renderChannelModalItem from '../functions/renderChannelModalItem'

const ChannelCreatePost = ({linkTo, children, onClose = NullAsDefault, ...props}) => {
    const t = useTranslate()

    const history = useHistory()

    const [isToggle, toggle] = useToggle(false)

    const onCancel = () => {
        toggle(false)
        onClose()
    }

    const goTo = (item) => {
        if (linkTo) {
            toggle(false)
            linkTo(item)
        } else {
            const detailLink = getLinkToDetail(item)
            history.push(detailLink)
        }
    }

    return (
        <React.Fragment>
            {children(toggle)}
            <Modal
                width={620}
                closable={true}
                closeIcon={null}
                open={isToggle}
                maskClosable={true}
                onCancel={onCancel}
                destroyOnHidden={true}
                title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('Choose the channel for posting')}
                    </div>
                }
                className="custom-modal"
                cancelText={t('cancel')}
                okButtonProps={{ hidden: true }}
                cancelButtonProps={{
                    className: 'button-rounded-lg no-border text-color-200',
                }}>
                <div className="mt-6">
                    <ChannelPickerContent
                        onCancel={onCancel}
                        onItemClick={(item) => {
                            Modal.destroyAll()
                            goTo(item)
                        }}
                        {...props}
                    />
                </div>
            </Modal>
        </React.Fragment>
    )
}

const ChannelPickerContent = ({
                                  onCancel = NullAsDefault,
                                  onItemClick = (item) => null,
                                  ...props
                              }) => {
    const t = useTranslate()
    const history = useHistory()
    const {refreshToken} = history?.location?.state ?? {}
    const refreshKey = [refreshToken, props.refreshKey]
    return (
        <LazyPagination
            {...props}
            key={refreshKey}
            renderEmpty={() => <EmptyHolder/>}
            renderWrap={(child) => (
                <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between gap-2">
                        <span className="flex-1 font-medium text-color-300 tracking-wide uppercase">
                          {t('list of channel')}
                        </span>
                        {/*<Button*/}
                        {/*    type="primary"*/}
                        {/*    icon={<RiAddFill size={11}/>}*/}
                        {/*    onClick={() => {*/}
                        {/*        history.push({*/}
                        {/*            pathname: staticPaths.createChannel.pathname,*/}
                        {/*            state: {*/}
                        {/*                isModal: true,*/}
                        {/*                willRedirect: false,*/}
                        {/*            },*/}
                        {/*        })*/}
                        {/*    }}*/}
                        {/*    style={{padding: '4px 12px', height: 'unset', fontSize: '12px'}}*/}
                        {/*    className="button-rounded-md no-border flex flex-center gap-2">*/}
                        {/*    {t('create channel')}*/}
                        {/*</Button>*/}
                    </div>
                    {child}
                </div>
            )}
            renderItem={(item, index) =>
                renderChannelModalItem(item, {
                    t,
                    index,
                    onItemClick,
                })
            }
        />
    )
}

export default ChannelCreatePost
